import React from "react";
import { Alert, Button, Row, Col } from "antd";
import { Link } from "react-router";

interface AccessInfo {
  accessible: boolean;
  reason?: string;
  message?: string;
}

interface PaymentStatusAlertsProps {
  access: AccessInfo;
  isOrganizationOwner: boolean;
}

const PaymentStatusAlerts: React.FC<PaymentStatusAlertsProps> = ({
  access,
  isOrganizationOwner
}) => {
  if (access.accessible && !access.reason) {
    return null;
  }

  const renderAlert = () => {
    switch (access.reason) {
      case 'payment_overdue':
        return (
          <Alert
            message="Code Identifier Temporarily Unavailable"
            description={
              <div>
                <p>{access.message}</p>
                {isOrganizationOwner && (
                  <div style={{ marginTop: '12px' }}>
                    <Link to="/organization/subscription">
                      <Button type="primary" size="small">
                        Manage Billing →
                      </Button>
                    </Link>
                  </div>
                )}
              </div>
            }
            type="error"
            showIcon
            style={{ marginBottom: '16px' }}
          />
        );
      
      case 'payment_due':
        return (
          <Alert
            message="Payment Notice"
            description={
              <div>
                <p>{access.message}</p>
                {isOrganizationOwner && (
                  <div style={{ marginTop: '12px' }}>
                    <Link to="/organization/subscription">
                      <Button type="default" size="small">
                        View Billing →
                      </Button>
                    </Link>
                  </div>
                )}
              </div>
            }
            type="warning"
            showIcon
            style={{ marginBottom: '16px' }}
          />
        );
      
      case 'subscription_required':
        return (
          <Alert
            message="Subscription Required"
            description={
              <div>
                <p>{access.message}</p>
                {isOrganizationOwner && (
                  <div style={{ marginTop: '12px' }}>
                    <Link to="/organization/subscription">
                      <Button type="primary" size="small">
                        Set Up Subscription →
                      </Button>
                    </Link>
                  </div>
                )}
              </div>
            }
            type="info"
            showIcon
            style={{ marginBottom: '16px' }}
          />
        );
      
      default:
        return null;
    }
  };

  return (
    <Row justify="center" style={{ marginBottom: "16px" }}>
      <Col xs={24} sm={24} md={18} lg={16} xl={14}>
        {renderAlert()}
      </Col>
    </Row>
  );
};

export default PaymentStatusAlerts; 